import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useEffect, useState } from 'react';
import { FormWrapper, FormContainer, MopActionWrapper, LinkWrapper, LinkWithDisabledStyle } from './styled';
import { useDispatch } from 'react-redux';
import { updatePaymentState } from '../../redux/PaymentState/PaymentState.actions';
import { SubType, ElementType, SharedCommandNames, PaymentMethodsCommandNames, StatusTypes, SpecType, sendRioEvent } from '@chegg/commerce-utils';
import { saveConfigs } from '../../redux/ConfigState/ConfigState.actions';
import { getPaymentFieldLabelText, hasFormFieldErrors, setInitialState } from './helpers';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import LoadingIndicator from '../LoadingIndicator';
import FormHeader from './FormHeader';
import { setEditableMop } from '../../redux/MopOnFileState/MopOnFileState.actions';
import { LoadingIndicatorStyle } from '../LoadingIndicator/types';
import PaymentButtons from '../PaymentButtons/PaymentButtons';
import * as UA from '@chegg/user-address';
import { setAppMode } from '../../redux/AppModeState/AppModeState.actions';
import { PaymentMethods } from '../../constants/PaymentTypes';
import { Component } from '../../constants/CallbackConstants';
import { PaymentFormDataFields } from '../../internals/UserAddress/constants';
import { ERRORS } from '../../constants/Errors';
import { Button } from '@chegg-ui/button';
import { getString } from '../../constants/Strings';
import { doFireStatusUpdate, sendRioEventCallback } from '../../utils/CallbackUtils';
import { sendNewRelicMessage } from '../../utils/NewRelicUtils';
import { onEdit } from '../DefaultMopView/helpers';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { paymentSelector } from '../../redux/PaymentState/PaymentState.selectors';
import { appModeSelector } from '../../redux/AppModeState/AppModeState.selectors';
import { AppMode } from '../../redux/AppModeState/AppModeState.types';
import { mopOnFileSelector } from '../../redux/MopOnFileState/MopOnFileState.selectors';
import VenmoView from '../VenmoView';
import FormInputs from './FormInputs';
var PaymentForm = function PaymentForm(props) {
  var config = useAppSelector(configSelector);
  var payment = useAppSelector(paymentSelector);
  var mopOnFile = useAppSelector(mopOnFileSelector);
  var appMode = useAppSelector(appModeSelector);
  var submit = config.submit,
    mopCreated = config.mopCreated,
    ui = config.ui,
    regexValidation = config.regexValidation,
    supportedPaymentMethods = config.supportedPaymentMethods,
    priceSummary = config.priceSummary,
    debug = config.debug,
    rioNamespace = config.rioNamespace,
    paymentForm = config.paymentForm;
  var _ref = ui,
    displayLoadingIndicator = _ref.displayLoadingIndicator,
    showSubmitButton = _ref.showSubmitButton;
  var formFields = payment.formFields,
    isLoading = payment.isLoading,
    billingAddress = payment.billingAddress,
    deviceData = payment.deviceData;
  var selectedMop = mopOnFile.selectedMop,
    paymentMethods = mopOnFile.paymentMethods,
    venmo = mopOnFile.venmo;
  var venmoInitialized = venmo === null || venmo === void 0 ? void 0 : venmo.venmoInitialized;
  var username = venmo === null || venmo === void 0 ? void 0 : venmo.username;
  var goBackMode = appMode.goBackMode,
    mode = appMode.mode;
  var clientInstance = props.clientInstance,
    hostedFieldsService = props.hostedFieldsService,
    isEdit = props.isEdit,
    testIsDisabled = props.testIsDisabled,
    optimizelyClient = props.optimizelyClient;
  var dispatch = useDispatch();
  var _useState = useState(formFields),
    _useState2 = _slicedToArray(_useState, 2),
    formData = _useState2[0],
    setFormData = _useState2[1];
  var _useState3 = useState(setInitialState(testIsDisabled, false)),
    _useState4 = _slicedToArray(_useState3, 2),
    isDisabled = _useState4[0],
    setIsDisabled = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    venmoInProgress = _useState6[0],
    setVenmoInProgress = _useState6[1];
  var isInitializing = !!(hostedFieldsService !== null && hostedFieldsService !== void 0 && hostedFieldsService.getIsInitializing());
  var hasFormErrors = hasFormFieldErrors(formFields);
  var hasMops = !!(paymentMethods.length > 0);

  // state will reflect whatever the current state of the field is from the braintree hosted fields side
  useEffect(function () {
    setFormData(formFields);
    if (mopCreated) {
      dispatch(saveConfigs({
        mopCreated: false
      }));
    }
    // when triggering submit externally, listen for the config change
    if (submit) {
      submitForm();
    }
    if (hasFormErrors) {
      setIsDisabled(false);
    }
  }, [submit, formFields, mopCreated]);
  useEffect(function () {
    venmoInitialized && setVenmoInProgress(true);
  }, [venmoInitialized]);
  useEffect(function () {
    // GCE-4900: tracking whether add or edit card button has been set to enabled state
    if (!isDisabled && (hasMops || showSubmitButton)) {
      sendRioEvent({
        info: getString("APP.RIO.EVENTS.EL_NAME.".concat(isEdit ? 'UPDATE' : 'ADD', "_CARD_ACTIVATED")),
        specType: SpecType.COMPONENT_VIEW,
        subType: SubType.COMPONENT,
        callback: sendRioEventCallback,
        namespace: rioNamespace,
        force: false
      });
    }
  }, [isDisabled]);
  useEffect(function () {
    // initialize hosted fields once only when DOM is mounted
    if (hostedFieldsService && !hostedFieldsService.isInitialized) {
      hostedFieldsService.initialize();
    }
    if (!isEdit) {
      sendRioEvent({
        info: getString('APP.RIO.EVENTS.EL_NAME.ADD_PM_LOADED'),
        specType: SpecType.COMPONENT_VIEW,
        subType: SubType.COMPONENT,
        callback: sendRioEventCallback,
        namespace: rioNamespace,
        force: false
      });
      sendRioEvent({
        info: getString('APP.RIO.EVENTS.EL_NAME.ADD_CARD_SHOWN'),
        specType: SpecType.COMPONENT_VIEW,
        subType: SubType.COMPONENT,
        callback: sendRioEventCallback,
        namespace: rioNamespace,
        force: false
      });
    } else {
      sendRioEvent({
        info: getString('APP.RIO.EVENTS.EL_NAME.EDIT_PM_LOADED'),
        specType: SpecType.COMPONENT_VIEW,
        subType: SubType.COMPONENT,
        callback: sendRioEventCallback,
        namespace: rioNamespace,
        force: false
      });
    }
  }, []);
  useEffect(function () {
    if (!isLoading && !hasMops) {
      doFireStatusUpdate([{
        status: StatusTypes.SUCCESS,
        command: PaymentMethodsCommandNames.PAYMENT_FORM_INITIALIZED,
        payload: {
          component: Component.PAYMENT_FORM
        }
      }]);
    }
  }, [isLoading]);
  useEffect(function () {
    if ((supportedPaymentMethods === null || supportedPaymentMethods === void 0 ? void 0 : supportedPaymentMethods.length) === 0) {
      var _ERRORS$NO_SUPPORTED_ = ERRORS.NO_SUPPORTED_PAYMENT_METHODS,
        message = _ERRORS$NO_SUPPORTED_.message,
        code = _ERRORS$NO_SUPPORTED_.code;
      dispatch(updatePaymentState({
        message: {
          text: message,
          type: StatusTypes.ERROR,
          code: code
        }
      }));
      doFireStatusUpdate([{
        status: StatusTypes.ERROR,
        command: SharedCommandNames.INITIALIZE,
        payload: {
          component: Component.PAYMENT_FORM,
          errors: [ERRORS.NO_SUPPORTED_PAYMENT_METHODS]
        }
      }]);
      sendNewRelicMessage('User has no supported methods of payment on checkout', {
        errors: JSON.stringify({
          priceSummary: priceSummary
        })
      });
    }
  }, [supportedPaymentMethods]);

  // CardFormView is lazy loaded so hosted fields are not initialized on the first load of the page
  // So once DOM selectors are available we can initialize hosted fields and prefill values on click of edit
  useEffect(function () {
    mode === AppMode.EDIT && onEdit({
      mop: selectedMop,
      dispatch: dispatch,
      hostedFieldsService: hostedFieldsService,
      rioNamespace: rioNamespace
    });
  }, [mode]);
  function onFormSubmit(_x) {
    return _onFormSubmit.apply(this, arguments);
  }
  function _onFormSubmit() {
    _onFormSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            //Rio logging: When a user clicks on Card CTA
            sendRioEvent({
              info: getString("APP.RIO.EVENTS.EL_NAME.CARD_CTA_CLICKED_".concat(isEdit ? 'UPDATE' : 'ADD')),
              specType: SpecType.INTERACTION,
              subType: SubType.CLICK,
              elementType: ElementType.BUTTON,
              callback: sendRioEventCallback,
              namespace: rioNamespace
            });
            dispatch(saveConfigs({
              submit: true
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _onFormSubmit.apply(this, arguments);
  }
  function submitForm() {
    dispatch(saveConfigs({
      submit: false
    }));
    var merged = _objectSpread(_objectSpread({}, formFields), formData);
    var city = billingAddress.city,
      state = billingAddress.state,
      zip = billingAddress.zip,
      country = billingAddress.country;
    UA.verify({
      type: 'minimal',
      address: {
        city: city,
        state: state,
        zipCode: zip,
        countryISO: country
      },
      regexValidation: regexValidation || false,
      callback: function callback(isValidAddress) {
        hostedFieldsService && hostedFieldsService.submit({
          formFields: merged,
          billingAddress: billingAddress,
          isValidAddress: isValidAddress && !formFields.userAddress.error,
          deviceData: deviceData,
          hasMops: hasMops,
          showSubmitButton: showSubmitButton
        });
      },
      debug: debug
    });
  }
  var onCancelClick = function onCancelClick(e) {
    e.preventDefault();
    // do not allow user to exit when hosted fields is initializing to prevent tear down after teardown error
    if (isInitializing) return;

    //Rio logging: Cancel Clicked On Payment Methods Component
    sendRioEvent({
      info: getString("APP.RIO.EVENTS.EL_NAME.CANCEL_PAYMENT_METHOD_CLICKED_".concat(isEdit ? 'EDIT' : 'NEW')),
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.BUTTON,
      callback: sendRioEventCallback,
      namespace: rioNamespace
    });
    dispatch(setEditableMop({
      mop: null
    }));
    dispatch(setAppMode({
      mode: goBackMode,
      goBackMode: goBackMode
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isEdit && !venmoInProgress && /*#__PURE__*/React.createElement(PaymentButtons, {
    clientInstance: clientInstance,
    optimizelyClient: optimizelyClient
  }), venmoInProgress && /*#__PURE__*/React.createElement(VenmoView, {
    username: username,
    goBackMode: goBackMode,
    isInitializing: isInitializing
  }), hostedFieldsService && !venmoInProgress && (supportedPaymentMethods === null || supportedPaymentMethods === void 0 ? void 0 : supportedPaymentMethods.includes(PaymentMethods.CREDITCARD)) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormWrapper, {
    id: 'pm-payment-form',
    "data-test": DataTestAttributes.CREDIT_CARD_FORM
  }, /*#__PURE__*/React.createElement(FormHeader, {
    isEdit: isEdit
  }), /*#__PURE__*/React.createElement(FormContainer, {
    "data-test": DataTestAttributes.CREDIT_CARD_FORM_CONTAINER,
    role: 'group',
    "aria-labelledby": 'pm-payment-form-header'
  }, (isLoading || isInitializing) && displayLoadingIndicator && /*#__PURE__*/React.createElement(LoadingIndicator, {
    LoadingType: LoadingIndicatorStyle.OVERLAY
  }), /*#__PURE__*/React.createElement(FormInputs, {
    formData: formData,
    isEdit: isEdit
  }))), (hasMops || showSubmitButton) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MopActionWrapper, null, hasMops && /*#__PURE__*/React.createElement(LinkWrapper, null, /*#__PURE__*/React.createElement(LinkWithDisabledStyle, {
    "data-test": DataTestAttributes.ADD_CARD_CANCEL_BUTTON,
    hasButtonBehavior: true,
    onClick: onCancelClick,
    href: isInitializing ? '' : '#',
    role: 'button',
    "aria-disabled": isInitializing,
    disabled: isInitializing,
    className: 'payment-form-cancel-button'
  }, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.CANCEL) || getString('APP.MOPONFILE.CANCEL'))), /*#__PURE__*/React.createElement(Button, {
    onClick: onFormSubmit,
    disabled: isDisabled || isLoading,
    "data-test": DataTestAttributes.CC_FORM_SUBMIT_BUTTON,
    disableHoverAnimation: true
  }, /*#__PURE__*/React.createElement("span", null, isEdit ? getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.UPDATE_CARD) || getString("APP.FORM.BUTTON.UPDATE") : getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.ADD_CARD) || getString("APP.FORM.BUTTON.ADD")))))));
};
export default PaymentForm;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PaymentForm/PaymentForm.js
// module id = 4539
// module chunks = 11